import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=3f3b0106&scoped=true"
import script from "./CatalogForm.vue?vue&type=script&lang=ts"
export * from "./CatalogForm.vue?vue&type=script&lang=ts"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&id=3f3b0106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b0106",
  null
  
)

export default component.exports